

































































































import { Prop, Component, Mixins } from "vue-property-decorator";
import InputMixin from "../private/InputMixin";
import NumericMixin from "../mixins/NumericMixin";
import NumberUtils from "./NumberUtils";
import {AbcMaskDirective} from "../directives/AbcMask";

@Component({
    directives: {
        focus: {
            inserted: function (el, binding) {
                if (binding.value) {
                    el.focus();
                }
            },
        },
        AbcMaskDirective
    },
})
export default class AbcInput extends Mixins(InputMixin, NumericMixin) {
    @Prop({ default: "off" }) autocomplete!: string;
    @Prop({ default: -1 }) decimals!: number;
    @Prop({ type: Boolean }) isDisabled!: boolean;
    @Prop({ type: Boolean }) isFocused!: boolean;
    @Prop({ type: Boolean }) isNumeric!: boolean;
    @Prop({ type: Boolean }) isPassword!: boolean;
    @Prop({ type: Boolean }) isUppercase!: boolean;
    @Prop({ default: null }) label!: string | null;
    @Prop({ default: null }) info!: string | null;
    @Prop({ type: Boolean }) leftTools!: boolean;
    @Prop({ default: 100 }) maxlength!: number;
    @Prop({ default: null }) placeholder!: string | null;
    @Prop({ type: Boolean }) rightTools!: boolean;
    @Prop({ type: Boolean }) buttons!: boolean;
    @Prop({ type: Boolean }) textRight!: boolean;
    @Prop({ type: String }) locale!: string | undefined;
    @Prop({ type: String, default: "" }) mask!: string;
    @Prop({ type: Boolean}) removeTrailingZero!: boolean;

    private rawValue: string | null = null;
    private haveFocus = false;
    private haveHover = false;

    private get computedMaxLength(){
        if(this.isNumeric){
            const [thousandSep, decimalSep] = NumberUtils.computeSeperators(this.locale);
            const parts = this.currentVal?.split(decimalSep);
            if(parts && parts.length > 1){
                return parts[0].length + NumberUtils.maxDecimals(this.decimals) + 1
            }
        }
        return this.maxlength;
    }

    get curMask() {
        if (this.isNumeric && !this.mask) {
            return this.numericAbcMask(this.decimals, this.locale)
        }
        return this.mask;
    }

    private get currentVal(): string | null {
        let ret: string | null = null;

        if (this.value === null || this.value === undefined) {
            ret = null;
        } else if (typeof this.value === "string" || !this.isNumeric) {
            ret = "" + this.value;
        } else if (this.haveFocus) {
            ret = this.rawValue;
        } else if (typeof this.value === "number") {
            ret = this.stringify(this.value);
        } else {
            ret = this.value + "";
        }

        if (ret && this.isUppercase) {
            ret = ret.toUpperCase();
        }

        return ret;
    }

    private set currentVal(val: string | null) {
        if (this.isUppercase && val) {
            val = val.toUpperCase();
        }

        this.rawValue = val;

        let input: string | number | null = val;
        if (this.isNumeric) {
            input = NumberUtils.parse(input, this.locale);
        }

        this.runRules(input);
        this.$emit("input", input);
    }

    private updateCurrentVal(e: any) {
        const inputVal = e.data;
        if (typeof inputVal != "undefined") {
            this.currentVal = e.target.value;
        }
    }

    private focusChanged(on: boolean) {
        if (typeof this.value !== "number") {
            if (this.isNumeric && this.value) {
                throw new Error(`FormInput configured as numeric but passed in value '${this.value}' is not a number`);
            }
            this.rawValue = this.value ? this.value + "" : "";
        } else if (this.isNumeric) {
            this.rawValue = this.stringify(this.value)
        }

        this.haveFocus = on;
        if (!on) {
            this.runRules(this.value);
            this.$emit("blur");
        } else {
            this.$emit("focus");
        }
    }

    private preventChars(evt: KeyboardEvent) {
        if (!this.isNumeric) {
            return;
        }

        let prevent = false;
        if (evt.key) {
            prevent =
                (evt.key < "0" || evt.key > "9") &&
                evt.key !== "." &&
                evt.key !== "," &&
                evt.key !== "Enter" &&
                evt.key !== "-";
        } else {
            prevent =
                (evt.keyCode < 48 || evt.keyCode > 57) &&
                evt.keyCode !== 190 &&
                evt.keyCode !== 188 &&
                evt.keyCode !== 13;
        }

        if (prevent) {
            evt.preventDefault();
            evt.stopPropagation();
        }
    }

    private stringify(val: number): string {
        return NumberUtils.stringify(val, this.decimals, true, this.locale, this.removeTrailingZero);
    }

    //style
    private get wrapperClass(): { [key: string]: boolean } {
        return {
            "border-border dark:border-border-dark": !this.haveHover && !this.haveFocus && !this.haveErrors,
            "border-secondary-300":
                (this.haveHover || this.haveFocus) && !this.isDisabled && !this.haveErrors,

            "border-danger-400 dark:border-danger-dark-400": !!this.haveErrors,
            "border-danger-500 dark:border-danger-dark-500":
                (this.haveHover || this.haveFocus) && !this.isDisabled && !!this.haveErrors,

            "abc-input-focused": this.haveFocus && !this.haveErrors,
            "abc-input-focused-error": this.haveFocus && !!this.haveErrors,

            "bg-bg-100 dark:bg-bg-dark-100": !this.isDisabled,
            "bg-bg-500 dark:bg-bg-dark-500 text-label-primary dark:text-label-primary-dark": this.isDisabled,
        };
    }
    private get inputClass(): { [key: string]: boolean } {
        return {
            "pl-2": this.leftTools,
            "pr-2": this.rightTools || this.buttons,
            "text-right": this.textRight,
        };
    }
}
